export const REGEX_DIGIT = /^[0-9]$/;
export const REGEX_DIGIT_STRING = '[0-9]*';

export const REGEX_RECOVERY_CODE = /^[A-Za-z0-9]$/;
export const REGEX_RECOVERY_CODE_STRING = '[A-Za-z0-9]*';

export const RECOVERY_CODE_LENGTH = 9;
